module.exports = {
      id: "facebook-usage",
      viewBox: "0 0 7 15",
      url: "/" + "sprite-bc0169963456b1a4ad1bb8f1c406f483.svg#facebook",
      toString: function () {
        return this.url;
      }
    }